import script from "./DlLogArea.vue?vue&type=script&lang=ts&setup=true"
export * from "./DlLogArea.vue?vue&type=script&lang=ts&setup=true"

import "./DlLogArea.vue?vue&type=style&index=0&id=8b1bec08&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b1bec08"]])

export default __exports__